import React from 'react';

const Help = () => {
  return (
    <div>
      <h2>Help & Support</h2>
      <p>FAQs: How do I reset my password? Use the Forgot Password link.</p>
      <a href="/contact">Contact Us</a>
    </div>
  );
};

export default Help;